import { motion } from 'framer-motion';

export function LoadingState({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <div className="w-full h-full min-h-[200px] flex flex-col items-center justify-center gap-3">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
        className="w-10 h-10 rounded-full border-2 border-gold-500/30 border-t-gold-400"
      />
      <span className="text-white/50 text-sm">{label}</span>
    </div>
  );
}

export function EmptyState({ title, subtitle, icon }: { title: string; subtitle?: string; icon?: string }) {
  return (
    <div className="w-full h-full min-h-[200px] flex flex-col items-center justify-center gap-2 px-6 text-center">
      <div className="text-4xl mb-1 opacity-70">{icon ?? '♠️'}</div>
      <div className="text-white/80 font-semibold">{title}</div>
      {subtitle && <div className="text-white/40 text-sm">{subtitle}</div>}
    </div>
  );
}

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="w-full h-full min-h-[200px] flex flex-col items-center justify-center gap-3 px-6 text-center">
      <div className="text-4xl mb-1">⚠️</div>
      <div className="text-rose-300 font-semibold">Что-то пошло не так</div>
      <div className="text-white/40 text-sm">{message}</div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-2 px-4 py-2 rounded-lg bg-ink-700 text-white/80 text-sm hover:bg-ink-600"
        >
          Повторить
        </button>
      )}
    </div>
  );
}
